import Service from "../../AuthService";

const insurance = {
    getInsurance(page) {
        return Service.get("/insurance-fee?page="+page);
    },
    showInsurance(id,page) {
        return Service.get("/insurance-fee/"+id+'?page='+page);
    },
    createInsurance(data){
      return Service.post("/insurance-fee",data)
    },
    quit(data){
      return Service.post("/insurance-quit",data)
    },
    editInsurance(data){
        return Service.post("/edit-insurance-fee",data);
    },
    search(page,driver){
        return Service.post("/insurance-fee-search?page=" +page+
            "&driver="+driver)
    },
    getInsuranceTotal(){
        return Service.get("/insurance-fee-total");
    },
    getQuitData(id){
        return Service.get("/get_quit_data?id="+id);
    },
    /*update 5/5/2020*/
    deleteInsurance(id){
        return Service.delete("/insurance-fee/"+id);
    }
};
export default insurance;
